export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#wishlist-v2-filled","viewBox":"0 0 14 13"}